import { gsap, ScrollTrigger } from './gsap';

export function initParallax() {
    initImageParallax();
    initTextParallax();
}

function initImageParallax() {
    document.querySelectorAll( '[data-parallax]' ).forEach( ( track ) => {
        gsap.to( track, {
            yPercent: 20,
            ease: 'none',
            scrollTrigger: {
                trigger: track.closest( '[data-parallax-container]' ) ?? track.parentElement,
                start: 'top bottom',
                end: 'bottom top',
                scrub: true,
            },
        } );
    } );
}

function initTextParallax() {
    document.querySelectorAll( '[data-parallax-text]' ).forEach( ( content ) => {
        gsap.to( content, {
            yPercent: -30,
            ease: 'none',
            scrollTrigger: {
                trigger: content.closest( 'section' ) ?? content.parentElement,
                start: 'top bottom',
                end: 'bottom top',
                scrub: true,
            },
        } );
    } );
}
